import { 
    apiRequest,
    AwardReject,
    AwardTypeList,
    AwardDetail
} from '../../../../../services/adapters/kepegawaian/penghargaanService'
import {
    homeList,
} from "../../../../../services/adapters/kepegawaian/homeService"

class ApproveRepository {

    fetchDetail = async (query, cancelToken) => {
        return await apiRequest("get", AwardDetail, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }

    fetchReject = async (query) => {
        return await apiRequest('post', AwardReject, {
            body: query
        }, true)
    }

    fetchType = async (query, cancelToken) => {
        return await apiRequest('get', AwardTypeList, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }
 
    fetchEmployeeList = async (query) => {
        return await apiRequest("get", homeList, {
            params: query
        }, true)
    }


}

export default ApproveRepository